import { ConfigProvider, Form } from 'antd';
import locale from 'antd/lib/locale/id_ID';
import DatePicker from 'src/components/Forms/DatePicker';
import ImageC from 'src/components/Image';
import dayjs from 'src/utils/moment';
import style from './style.module.less';
const DatePickerKalkulator = (props: any) => {
  const {
    onChange,
    className
  } = props;
  const isRequired = props.rules ? props.rules.filter((r: any) => r.required === true).length > 0 : false;
  return <ConfigProvider locale={locale}>
			<Form.Item label={props.useLabel ? props.label : ''} name={props.name} required={isRequired}>
				<DatePicker name="calendar" disabledDate={current => {
        return current.isAfter(dayjs(), 'day') || current.isBefore(dayjs().add(-2, 'month'));
      }} allowClear={false} showToday={false} dropdownClassName={style.modalCalendar} format={'DD/MM/YYYY'}
      // defaultValue={dayjs()}
      // defaultPickerValue={dayjs()}
      onChange={onChange} className={className} style={{
        width: '100%'
      }} placeholder="Pilih Tanggal HPHT Mama" suffixIcon={<ImageC alt="Calendar" src="/images/default/calendar.svg" width={24} height={24} />} />
			</Form.Item>
		</ConfigProvider>;
};
export default DatePickerKalkulator;